import React, { Component } from "react";
// import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const deriveState = props => {
  const { rowsData, rowIndex, value, fromPopup } = props;
  if (fromPopup) {
    return value;
  }
  return rowsData[rowIndex].is_active;
};

class CheckboxEditor extends Component {
  state = {
    value: this.props.value,
    // value: deriveState(this.props)
  };

  componentDidMount() {
    // Flip the value if it's not on the popup and editing started via enter key
    if (!this.props.fromPopup && this.props.keyPress === 13) {
      this.flipCheckboxValue();
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ value: deriveState(nextProps) });
  }

  getValue() {
    // console.debug(this.state.value);
    return this.state.value;
  }

  flipCheckboxValue = () => {
    this.setState((state, props) => {
      if (this.props.fromPopup) {
        this.props.returnValue(!state.value);
      }
      return {
        value: !state.value,
      };
    });
  };

  onKeyPressed = e => {
    console.debug(e.keyPress);
    console.debug(this.props);
  };

  render() {
    // console.debug(this.props);
    let classNames = "form-check text-center";
    let labelText = "";
    if (this.props.fromPopup) {
      classNames = "form-check";
      labelText = this.props.labelText;
    }
    let checkBox;
    // Checkbox on Popup
    if (this.props.fromPopup) {
      checkBox = (
        <div className={classNames}>
          <input
            type="checkbox"
            className="form-check-input"
            id="exampleCheck1"
            checked={this.state.value}
            onChange={this.flipCheckboxValue}
          />
          <label className="form-check-label" htmlFor="exampleCheck1">
            {labelText}
          </label>
        </div>
      );
    } else {
      // Checkbox on Grid
      // let renderValue = <p className="text-danger text-bold text-center">Inactive</p>;
      if (this.state.value) {
        checkBox = (
          <span
            className="checkbox-renderer-span"
            onClick={this.flipCheckboxValue}>
            <FontAwesomeIcon
              icon={["far", "check-square"]}
              color="green"
              size="lg"
            />
          </span>
        );
        // renderValue = <p className="text-success text-bold text-center">Active</p>;
      } else {
        checkBox = (
          <span
            className="checkbox-renderer-span"
            onClick={this.flipCheckboxValue}>
            <FontAwesomeIcon icon={["far", "square"]} color="green" size="lg" />
          </span>
        );
      }
    }
    return <div>{checkBox}</div>;
    // return <div style={{ background: "#dfdfdf" }}>{checkBox}</div>;
  }
}

export default CheckboxEditor;
// const mapStateToProps = state => {
//   // console.debug(state);
//   const rowsData = state.rowsData ? state.rowsData : [];
//   return { rowsData };
// };

// // const mapDispatchToProps = {
// //   fetchColumnsDataFromDB,
// //   fetchAllProducts
// // };

// export default connect(
//   mapStateToProps,
//   // mapDispatchToProps
//   null
// )(CheckboxEditor);



// WEBPACK FOOTER //
// ./src/components/cell-editors/CheckboxEditor.js